// import { h } from 'vue'
// import { Switch } from 'ant-design-vue'

export function useCommon() {
  const columns = [
    {
      title: '奖励图片',
      dataIndex: 'imageUrl',
      key: 'imageUrl'
    },
    {
      title: '奖项名称',
      dataIndex: 'prizeName',
      key: 'prizeName'
    },
    {
      title: '奖励类型',
      dataIndex: 'prizeType',
      key: 'prizeType',
      customRender({ text }) {
        const ival = {
          1: '优惠券',
          2: '积分',
          3: '谢谢参与',
          4: '自定义',
          5: '实物'
        }
        return ival[text]
      } //1.优惠券,2.积分,3.谢谢参与,4.自定义
    },
    {
      title: '中奖概率',
      dataIndex: 'probability',
      key: 'probability',
      align: 'right'
    },
    {
      title: '总库存',
      dataIndex: 'totalInventory',
      key: 'totalInventory',
      align: 'right'
    },
    {
      title: '单日库存',
      dataIndex: 'oneDayInventory',
      key: 'oneDayInventory',
      align: 'right'
    },
    {
      title: '用户活动获得上限',
      dataIndex: 'fetchUpperLimit',
      key: 'fetchUpperLimit',
      align: 'right'
    },
    {
      title: '是否展示用户获奖记录',
      dataIndex: 'showRecord',
      key: 'showRecord',
      customRender({ text }) {
        return text ? '是' : '否'
      }
    },
    {
      title: '是否为兜底奖项',
      dataIndex: 'defaultPrize',
      key: 'defaultPrize',
      customRender({ text }) {
        return text ? '是' : '否'
      }
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status'
      //   customRender({ text }) {
      //     const checked = text === 1 ? true : false
      //     console.log('checked', checked)
      //     return h(Switch, { modelValue: checked })
      //   }
    },
    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions'
    }
  ]
  // let validateVal = async (rule, value) => {
  //   console.log('rule', rule)
  //   if (value === undefined || value === null || value === '') {
  //     return Promise.reject('请输入单日库存')
  //   } else if (value) {
  //     return Promise.reject('请输入数字')
  //   } else {
  //     return Promise.resolve()
  //   }
  // }
  const rules = {
    prizeType: [
      { required: true, trigger: 'change', message: '请选择获取方式类型' }
    ],
    discountRuleId: [
      { required: true, trigger: 'blur', message: '请输入优惠券规则ID' }
    ],
    validDays: [
      { required: true, trigger: 'blur', message: '请输入优惠券有效期' }
    ],
    scenesId: [
      { required: true, trigger: 'blur', message: '请输入积分发放场景ID' }
    ],
    prizeName: [{ required: true, trigger: 'blur', message: '请输入奖项名称' }],
    imageUrl: [{ required: true, trigger: 'change', message: '请上传图片' }],
    skcCode: [{ required: true, trigger: 'blur', message: '请输入奖项SKC' }],
    acquireValidDays: [
      { required: true, trigger: 'blur', message: '请输入领取有效期' }
    ],
    probability: [
      { required: true, trigger: 'blur', message: '请输入中奖概率' }
    ],
    totalInventory: [
      { required: true, trigger: 'blur', message: '请输入总库存' }
    ],
    oneDayInventory: [
      { required: true, trigger: 'blur', message: '请输入单日库存' }
    ],
    fetchUpperLimit: [
      { required: true, trigger: 'blur', message: '请输入用户活动获得上限' }
    ],
    defaultPrize: [
      { required: true, trigger: 'change', message: '请选择是否为兜底奖项' }
    ],
    status: [{ required: true, trigger: 'change', message: '请选择状态' }],
    showRecord: [
      { required: true, trigger: 'change', message: '请选择是否展示获奖记录' }
    ],
    jumpUrlWeb: [
      { required: true, trigger: 'blur', message: '请输入跳转链接-WEB' }
    ],
    jumpUrlApp: [
      { required: true, trigger: 'blur', message: '请输入跳转链接-APP' }
    ],
    point: [{ required: true, trigger: 'blur', message: '请输入中奖获取积分' }]
  }
  return { columns, rules }
}
